import { ReviewExtraModel } from "@core/models";

export class ReviewExtraDTO extends ReviewExtraModel {
  prepareReviewData() {
    return {
      demande_id: this.getDemandId(),
      extra_id: this.getExtraId(),
      note: this.getNote(),
      commentaire: this.getComment(),
    };
  }

  prepareDeclareExtraMissingData() {
    return {
      demande_id: this.getDemandId(),
      extra_id: this.getExtraId(),
      note: -1, // RG: to declare extra missing we put a note of -1
    };
  }
}
